import { render } from "./WideFab.vue?vue&type=template&id=4d00b0ce&scoped=true"
import script from "./WideFab.vue?vue&type=script&lang=js"
export * from "./WideFab.vue?vue&type=script&lang=js"

import "./WideFab.vue?vue&type=style&index=0&id=4d00b0ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d00b0ce"]])

export default __exports__